/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import EstateInput, { EstateInputProps } from '../inputs/EstateInput'
import { FormTextFieldProps } from '../../../../client/js/components/form/fields/FormField'
import { parseNumber } from '@jalik/form-parser'

function EstateField (props: FormTextFieldProps & Partial<EstateInputProps>) {
  const { name = 'estateId', ...others } = props

  const { errors, getFieldProps, handleSetValue } = useFormContext()
  const fieldProps = getFieldProps(name, others)

  return (
    <EstateInput
      error={errors[name]?.message}
      {...fieldProps}
      name={name}
      onChange={handleSetValue(name, { parse: parseNumber })}
    />
  )
}

export default EstateField
